// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell_cell__51MXr","horizontal":"cell_horizontal__FLYhh","vertical":"cell_vertical__1iUgv"};